import React from 'react';
import SegmentedControl from './SegmentedControl';

interface ToggleProps {
  value: boolean;
  onLabel: React.ReactNode;
  offLabel: React.ReactNode;
  size?: 'sm' | 'lg';
  onChange: (value: boolean) => void;
}

export default function Toggle({ value, onLabel, offLabel, size, onChange }: ToggleProps) {
  return <SegmentedControl
    size={size}
    options={[{ value: 'off', label: offLabel }, { value: 'on', label: onLabel }]}
    value={value ? 'on' : 'off'}
    onChange={next => onChange(next === 'on')} />;
}
